import Component from '@glimmer/component'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { service } from '@ember/service'
import type WindowService from 'teacher-ui-client/services/window'
import { UiButton } from 'teacher-ui-client/components/ui-button'
import { on } from '@ember/modifier'
import { t } from 'ember-intl'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'

interface Args {
  disabled?: boolean
}

interface Signature {
  Args: Args
}

export class ReportingPrintButton extends Component<Signature> {
  @service window!: WindowService

  printAction = () => {
    this.window.getWindow.print()
  }

  <template>
    <UiButton
      data-test-print-button
      disabled={{@disabled}}
      @appearance={{ButtonAppearance.muted}}
      {{on "click" this.printAction}}
    >
      <PhosphorIcon @icon="phosphor-printer-fill" />
      {{t "components.reporting.exportSelect.labels.print"}}
    </UiButton>
  </template>
}

export default ReportingPrintButton
